var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "product-insights",
      staticStyle: { "margin-bottom": "30px" }
    },
    [
      _c(
        "carousel",
        {
          attrs: { "per-page": 5, navigationEnabled: true, "mouse-drag": false }
        },
        _vm._l(_vm.selfies, function(selfie) {
          return _c("slide", { key: selfie.id }, [
            _c("img", {
              staticClass: "img-responsive",
              staticStyle: { width: "95%", border: "2px solid #12db6d" },
              attrs: { src: selfie.image }
            })
          ])
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }